<template>
    <div class="threejsContainer">
      <div class="containerTitle">1-14.3D标签和跨图层展示</div>
      <div ref="container" class="containerBody"></div>
    </div>
  </template>
  
  <script>
  import * as THREE from 'three';
  import {generateScene} from '@/threejsEnv/scene.js';
  import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';
  import {genPerspectiveCamera} from '@/threejsEnv/camera.js';
  import {genRenderer} from '@/threejsEnv/renderer.js';
  
  export default {
    data() {
      return {
        scene: null,
        camera: null,
        renderer: null,
        controls: null,
        currentMesh: null,
        progress: 0,
        u_time: 0,
        window: {
          width: 0,
          height: 0
        },
        cube:null,
        cube1:null,
        animationId: null
      };
    },
    mounted() {
      //初始化环境
      this.initEnv();
      //创建网格对象
      this.createMesh();
      this.createMesh1();
      this.animate();
      // 监听窗口大小变化
      window.addEventListener('resize', this.onWindowResize);
    },
    methods: {
      createMesh() {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = 400;
        canvas.height = 100;

        // 文字内容和样式（不变）
        const text = '陕西省西安市雁塔区';
        ctx.font = 'bold 24px "Microsoft YaHei", Arial, sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        // 1. 计算文字尺寸和位置（不变）
        const textMetrics = ctx.measureText(text);
        const textWidth = textMetrics.width;
        const textHeight = 30;
        const padding = 15;

        const rectX = (canvas.width - textWidth) / 2 - padding;
        const rectY = (canvas.height - textHeight) / 2 - padding;
        const rectWidth = textWidth + padding * 2;
        const rectHeight = textHeight + padding * 2;

        // 2. 绘制矩形外框（不变）
        const borderRadius = 6;
        ctx.beginPath();
        ctx.moveTo(rectX + borderRadius, rectY);
        ctx.lineTo(rectX + rectWidth - borderRadius, rectY);
        ctx.arcTo(rectX + rectWidth, rectY, rectX + rectWidth, rectY + borderRadius, borderRadius);
        ctx.lineTo(rectX + rectWidth, rectY + rectHeight - borderRadius);
        ctx.arcTo(rectX + rectWidth, rectY + rectHeight, rectX + rectWidth - borderRadius, rectY + rectHeight, borderRadius);
        ctx.lineTo(rectX + borderRadius, rectY + rectHeight);
        ctx.arcTo(rectX, rectY + rectHeight, rectX, rectY + rectHeight - borderRadius, borderRadius);
        ctx.lineTo(rectX, rectY + borderRadius);
        ctx.arcTo(rectX, rectY, rectX + borderRadius, rectY, borderRadius);
        ctx.closePath();

        // 背景填充（不变）
        ctx.fillStyle = 'rgba(255, 0, 0, 0.1)';
        ctx.fill();

        // 边框（不变）
        ctx.strokeStyle = '#0000ff';
        ctx.lineWidth = 1;
        ctx.stroke();

        // 3. 绘制文字（不变）
        ctx.fillStyle = '#000000';
        ctx.fillText(text, canvas.width / 2, canvas.height / 2);

        // --------------------------
        // 关键修改：用平面替代 Sprite
        // --------------------------
        const texture = new THREE.CanvasTexture(canvas);
        // 平面材质（用 MeshBasicMaterial，确保双面可见）
        const planeMaterial = new THREE.MeshBasicMaterial({
          map: texture,
          side: THREE.DoubleSide // 重要：双面可见，避免旋转后文字看不见
        });
        // 平面几何体（宽高比例和画布一致，尺寸缩小50倍避免过大）
        const planeGeometry = new THREE.PlaneGeometry(canvas.width / 50, canvas.height / 50);
        const textPlane = new THREE.Mesh(planeGeometry, planeMaterial);

        // 调整平面位置（放在立方体上方）
        textPlane.position.y = 1.0;

        // 可选：初始旋转平面，让文字朝向正面（根据需求调整）
        // textPlane.rotation.y = Math.PI; // 旋转180度，文字朝向Z轴负方向（正前方）

        // 立方体相关代码（不变）
        const material1 = new THREE.MeshBasicMaterial({ color: 0x00ff00, wireframe: false });
        const geometry = new THREE.BoxGeometry();
        this.cube = new THREE.Mesh(geometry, material1);
        
        const cube1 = new THREE.Mesh(geometry, material1);
        cube1.position.x = -5.0;
        cube1.position.y = 1.5;

        // 将平面添加到立方体（关键：作为子对象，跟随立方体旋转）
        this.cube.add(textPlane);
        this.scene.add(this.cube);
        this.scene.add(cube1);
      },
      createMesh1() {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = 400; // 适当加大画布，容纳文字和边框
        canvas.height = 100;

        // 文字内容和样式
        const text = '陕西省西安市碑林区';
        ctx.font = 'bold 24px "Microsoft YaHei", Arial, sans-serif'; // 稍大字体
        ctx.textAlign = 'center'; // 文字水平居中
        ctx.textBaseline = 'middle'; // 文字垂直居中

        // 1. 计算文字尺寸和位置
        const textMetrics = ctx.measureText(text); // 获取文字宽度信息
        const textWidth = textMetrics.width; // 文字实际宽度
        const textHeight = 30; // 估算文字高度（略大于字体大小）
        const padding = 15; // 文字与边框的间距

        // 矩形框的位置和尺寸（基于文字居中）
        const rectX = (canvas.width - textWidth) / 2 - padding; // 矩形左上角X
        const rectY = (canvas.height - textHeight) / 2 - padding; // 矩形左上角Y
        const rectWidth = textWidth + padding * 2; // 矩形宽度（文字宽+左右边距）
        const rectHeight = textHeight + padding * 2; // 矩形高度（文字高+上下边距）

        // 2. 绘制矩形外框（带圆角更美观）
        const borderRadius = 6; // 矩形圆角半径
        ctx.beginPath();
        // 绘制圆角矩形路径
        ctx.moveTo(rectX + borderRadius, rectY);
        ctx.lineTo(rectX + rectWidth - borderRadius, rectY);
        ctx.arcTo(rectX + rectWidth, rectY, rectX + rectWidth, rectY + borderRadius, borderRadius);
        ctx.lineTo(rectX + rectWidth, rectY + rectHeight - borderRadius);
        ctx.arcTo(rectX + rectWidth, rectY + rectHeight, rectX + rectWidth - borderRadius, rectY + rectHeight, borderRadius);
        ctx.lineTo(rectX + borderRadius, rectY + rectHeight);
        ctx.arcTo(rectX, rectY + rectHeight, rectX, rectY + rectHeight - borderRadius, borderRadius);
        ctx.lineTo(rectX, rectY + borderRadius);
        ctx.arcTo(rectX, rectY, rectX + borderRadius, rectY, borderRadius);
        ctx.closePath();

        // 可选：添加矩形背景填充（让边框更清晰）
        ctx.fillStyle = 'rgba(0, 0, 0, 0.1)'; // 半透明黑色背景
        ctx.fill();

        // 绘制矩形边框
        ctx.strokeStyle = '#000000'; // 边框颜色（黑色）
        ctx.lineWidth = 1; // 边框粗细
        ctx.stroke();

        // 3. 绘制文字（在矩形框内居中）
        ctx.fillStyle = '#005555'; // 文字颜色（黑色）
        ctx.fillText(text, canvas.width / 2, canvas.height / 2);

        // 创建Sprite并调整大小
        const texture = new THREE.CanvasTexture(canvas);
        const material = new THREE.SpriteMaterial({ map: texture });
        const sprite = new THREE.Sprite(material);
        sprite.position.y = 1.0;
        sprite.scale.set(4, 1, 1); // 与画布尺寸匹配（宽度4，高度1）

        // 立方体相关代码（不变）
        const material1 = new THREE.MeshBasicMaterial({ color: 0x00ff00, wireframe: false });
        const geometry = new THREE.BoxGeometry();
        this.cube1 = new THREE.Mesh(geometry, material1);
        
        const cube1 = new THREE.Mesh(geometry, material1);
        cube1.position.x = 5.0;
        cube1.position.y = 1.5;

        this.cube1.add(sprite);
        this.scene.add(this.cube1);
        this.scene.add(cube1);

      },
      animate() {
        this.animationId = requestAnimationFrame(this.animate);
        this.controls.update();
        this.u_time += 0.01;
        this.cube.position.x = Math.sin(this.u_time)*5.0;
        this.cube.position.z = Math.cos(this.u_time)*5.0;
        this.cube1.position.x = Math.sin(this.u_time+Math.PI)*5.0;
        this.cube1.position.z = Math.cos(this.u_time+Math.PI)*5.0;
        this.renderer.render(this.scene, this.camera);
      },
      initEnv(){
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
        // 初始化场景
        this.scene = generateScene();
        this.scene.background = new THREE.Color(0xffffff);
  
        // 初始化相机
        this.camera = genPerspectiveCamera(this.window);
        this.camera.position.z =10.0;
  
        // 初始化渲染器
        this.renderer = genRenderer(this.window);
        this.$refs.container.appendChild(this.renderer.domElement);
  
        // 添加轨道控制器
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.controls.enableDamping = true;
  
        // 创建光源
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
        this.scene.add(ambientLight);
        
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
        directionalLight.position.set(10, 20, 15);
        this.scene.add(directionalLight);
  
        const gridHelper = new THREE.GridHelper(100, 100,
                                                0x666666,   // 中心轴线颜色（红色）
                                                0xcccccc    // 普通网格线颜色（绿色）
                                                ); // 10x10 网格
        this.scene.add(gridHelper);
      },
      onWindowResize() {
        const width = this.$refs.container.clientWidth;
        const height = this.$refs.container.clientHeight;
  
        // 更新相机
        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();
  
        // 更新渲染器
        this.renderer.setSize(width, height);
      }
    },
    beforeDestroy() {
      // 清理动画和事件监听
      cancelAnimationFrame(this.animationId);
      window.removeEventListener('resize', this.onWindowResize);
      
      // 释放资源
      if (this.currentMesh) {
        this.scene.remove(this.currentMesh);
        this.currentMesh.geometry.dispose();
        this.currentMesh.material.dispose();
      }
      
      this.controls.dispose();
      this.renderer.dispose();
      this.renderer.domElement.remove();
    }
  };
  </script>
  
  <style>
  </style>
  